export const videoPlayer = () => {
  const videoContainer = document.querySelectorAll('.wp-block-video');

  videoContainer.forEach((container) => {
    const parentEl = container.parentNode;
    const playButton = parentEl.querySelector('.video-player-button');
    const videoElement = container.querySelector('video');

    if (playButton) {
      if (videoElement.autoplay == true) {
        videoElement.muted = true;
        videoElement.loop = true;
        videoElement.playsInline = true;
        videoElement.controls = false;
        parentEl.classList.add('is-autoplay');
      } else {
        videoElement.controls = false;
      }

      playButton.addEventListener('click', () => {
        videoElement.controls = videoElement.paused ? true : false;
        playButton.hidden = videoElement.paused ? true : false;
        videoElement.paused ? videoElement.play() : videoElement.pause();
      });
    }
  });
};
